import { useQuery } from '@tanstack/react-query'

import type { Company } from '@albacross/types'

import { getCompaniesSearchBody } from 'models/company-model'
import type { Paginated } from 'utils/http'
import { post } from 'utils/http'

// Companies list: POST /management/companies/search with the filter body; pagination via query.
export const useCompanies = (meta: any) =>
  useQuery({
    queryKey: ['companies', meta],
    queryFn: () =>
      post<Paginated<Company>>('/management/companies/search', getCompaniesSearchBody(meta), {
        query: { limit: meta.rowsPerPage, offset: meta.page * meta.rowsPerPage },
      }),
  })
